<div>
  <span>{{ tag.name }}</span>
  <i (click)="deleteTag()">
    <svg width="7px" height="7px" viewBox="0 0 12 12">
      <path
        fill-rule="evenodd"
        d="M10.943,9.919 L9.888,10.974 L5.939,7.024 L1.990,10.974 L0.934,9.919 L4.884,5.969 L0.934,2.020 L1.990,0.965 L5.939,4.914 L9.888,0.965 L10.943,2.020 L6.994,5.969 L10.943,9.919 Z"
      />
    </svg>
  </i>
</div>
